exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".survey-closed-container[data-v-771466be]{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:2rem 1rem;background-color:#f5f5f5}.card[data-v-771466be]{box-shadow:0 2px 8px rgba(0,0,0,.1)}.card-header-title[data-v-771466be]{padding:2rem 1.5rem}.icon-wrapper[data-v-771466be]{display:inline-flex;align-items:center;justify-content:center;width:4rem;height:4rem;border-radius:50%}.icon-wrapper.muted[data-v-771466be]{background-color:#f5f5f5}.card-content[data-v-771466be]{padding:1.5rem}.card-footer-item[data-v-771466be]{padding:1.5rem;display:block}@media screen and (max-width:768px){.survey-closed-container[data-v-771466be]{padding:1rem}.card-header-title[data-v-771466be]{padding:1.5rem 1rem}.icon-wrapper[data-v-771466be]{width:3.5rem;height:3.5rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-771466be","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/sections/survey/SurveyClosed.vue
// module id = 1972
// module chunks = 2